<div class="flex flex-col flex-1 w-full min-h-full bg-gray-100 font-sans">
  <div class="flex-1 flex items-center justify-center w-full p-4">
    <div class="bg-white p-10 rounded-lg shadow-md w-full max-w-[440px] text-center mx-auto">
      @if (isProcessing()) {
      <!-- Processing State -->
      <div class="flex flex-col items-center">
        <div class="animate-spin h-10 w-10 border-4 border-blue-600 border-t-transparent rounded-full mb-6"></div>
        <h2 class="text-gray-800 text-2xl font-bold mb-2">Logging you in...</h2>
        <p class="text-gray-600 text-[0.95rem]">Please wait while we complete your authentication.</p>
      </div>
      } @else if (errorMessage()) {
      <!-- Error State -->
      <div class="flex flex-col items-center">
        <div class="text-5xl mb-4">⚠️</div>
        <h2 class="text-red-700 text-2xl font-bold mb-4">Authentication Error</h2>
        <p class="w-full p-3 px-4 rounded mb-6 text-sm text-left bg-red-100 text-red-800 border border-red-700">
          {{ errorMessage() }}
        </p>
        <p class="text-gray-500 text-sm italic">Redirecting to login page...</p>
      </div>
      }
    </div>
  </div>
  <app-footer></app-footer>
</div>